import { render, staticRenderFns } from "./add-to-wishlist-btn.vue?vue&type=template&id=706b5746&"
import script from "./add-to-wishlist-btn.vue?vue&type=script&lang=js&"
export * from "./add-to-wishlist-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports